import { render, staticRenderFns } from "./MoleculeChartBars.vue?vue&type=template&id=4ea5cc44"
import script from "./MoleculeChartBars.vue?vue&type=script&lang=js"
export * from "./MoleculeChartBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports